import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class OfficeGuard implements CanActivate {
  public canActivate() {
    let userProfile = JSON.parse(sessionStorage.getItem('user') || '{}');
    if (!userProfile || !userProfile.security || !userProfile.security.officeTab)
      return false;
    else return true;
  }

  // canActivateChild() {}
}